module.exports = {
  siteTitle: 'Portfolio', // <title>
  manifestName: 'Sean',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/portfolio/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'OLUWASEUN BELLO',
  subHeading: 'Full time Full-Stack Developer. Part time Technical Support Engineer @Microverse, USA.',

  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/bellom',
    },
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://linkedin.com/in/bellom/',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/bellom_sean',
    },
    {
      icon: 'fa-facebook-f',
      name: 'Facebook',
      url: 'https://facebook.com/oluwadamilare.bellomsean',
    },
  ],
  email: 'bellomsean@gmail.com',
  phone: '+2348086174428',
  address: 'Lagos, Nigeria',
};
